<template>
  <div class="acupointAdd">
    <!--返回按钮 -->
    <el-button
      @click="goback"
      type="primary"
      size="small"
      style="margin:0 0 20px 0"
      v-if="modify"
    >
      <i class="el-icon-back"></i> 返回上一页
    </el-button>
    <el-card shadow="never">
      <h1 v-if="modify">穴位修改</h1>
      <h1 v-else>穴位添加</h1>
      <el-form label-position="top" label-width="80px" :model="form">
        <el-form-item class="label-font" label="类型">
          <el-input
            disabled
            v-model="form.type"
            placeholder="请选择经络"
          ></el-input>
        </el-form-item>
        <el-form-item class="label-font" label="经络">
          <el-select
            v-model="form.cat_id"
            placeholder="请选择经络"
            style="width:100%;"
            @change="selectCatId"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="label-font" label="穴位名称">
          <el-input
            clearable
            v-model="form.name"
            placeholder="请输入穴位名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="label-font"
          label="概述图片 (建议比例750:400,文件大小不得超过2MB)"
        >
          <div
            v-if="form.definition_pic_path"
            class="previewAvatar"
            @mouseover="previewAvatarAcupointSelection = true"
            @mouseout="previewAvatarAcupointSelection = false"
            :class="{ previewAvatarHover: previewAvatarAcupointSelection }"
          >
            <div>
              <i
                class="el-icon-zoom-in icon-size"
                v-show="previewAvatarAcupointSelection"
                @click="handlePictureCardPreview(form.definition_pic_path)"
              ></i>
              <i
                class="el-icon-delete icon-size"
                v-show="previewAvatarAcupointSelection"
                @click="handlePictureDelete('definition_pic_path')"
              ></i>
            </div>
          </div>
          <el-upload
            class="avatar-uploader"
            :action="uploadAction"
            :show-file-list="false"
            :data="uploadToken"
            :accept="uploadAccept"
            :on-success="
              (res, file, fileList) =>
                handleAvatarSuccess(res, file, fileList, 1)
            "
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.definition_pic_path"
              :src="imgUrl + form.definition_pic_path"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item
          class="label-font"
          :label="formType == 1 ? '拼音' : '部位'"
        >
          <el-input
            clearable
            v-model="form.definition_pinyin"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="label-font"
          :label="formType == 1 ? '所属经络' : '操作手法'"
        >
          <el-input
            type="textarea"
            :rows="1"
            autosize
            v-model="form.definition_cat_belongs_to"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="label-font"
          :label="formType == 1 ? '主治' : '具体操作'"
        >
          <el-input
            type="textarea"
            :rows="1"
            autosize
            v-model="form.definition_major_functions"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="label-font"
          :label="formType == 1 ? '快速取穴' : '功效'"
        >
          <el-input
            type="textarea"
            :rows="1"
            autosize
            v-model="form.acupoint_selection_title"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="label-font"
          :label="formType == 1 ? '取穴内容' : '功效介绍'"
        >
          <el-input
            type="textarea"
            :rows="1"
            autosize
            v-model="form.acupoint_selection_content"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item class="label-font" label="适用范围" v-if="formType == 2">
          <el-input
            type="textarea"
            :rows="1"
            autosize
            v-model="form.acupoint_range"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item class="label-font" label="备注" v-if="formType == 2">
          <el-input
            type="textarea"
            :rows="1"
            autosize
            v-model="form.acupoint_mark"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="label-font"
          label="取穴图片 (建议比例750:400,文件大小不得超过2MB)"
          v-if="formType == 1"
        >
          <div
            v-if="form.acupoint_selection_pic_path"
            class="previewAvatar"
            @mouseover="previewAvatarAcupointSelection = true"
            @mouseout="previewAvatarAcupointSelection = false"
            :class="{ previewAvatarHover: previewAvatarAcupointSelection }"
          >
            <div>
              <i
                class="el-icon-zoom-in icon-size"
                v-show="previewAvatarAcupointSelection"
                @click="
                  handlePictureCardPreview(form.acupoint_selection_pic_path)
                "
              ></i>
              <i
                class="el-icon-delete icon-size"
                v-show="previewAvatarAcupointSelection"
                @click="handlePictureDelete('acupoint_selection_pic_path')"
              ></i>
            </div>
          </div>
          <el-upload
            class="avatar-uploader"
            :action="uploadAction"
            :show-file-list="false"
            :data="uploadToken"
            :accept="uploadAccept"
            :on-success="
              (res, file, fileList) =>
                handleAvatarSuccess(res, file, fileList, 2)
            "
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.acupoint_selection_pic_path"
              :src="imgUrl + form.acupoint_selection_pic_path"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item class="label-font" label="穴位配伍" v-if="formType == 1">
          <el-input
            type="textarea"
            :rows="1"
            autosize
            v-model="form.acupoint_match"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{
            confirmText
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 预览图片 -->
    <el-dialog :visible.sync="dialogVisibleImg">
      <img width="100%" :src="imgUrl + dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import { saveAcupoint, categoryList, acupointDetail } from "@/api/acupoint";
export default {
  name: "acupointAdd",
  data() {
    return {
      options: [], // 经络
      previewAvatarAcupointSelection: false,
      dialogImageUrl: "",
      dialogVisibleImg: false,
      form: {
        id: 0,
        name: "", // 经络名称
        cat_id: "", // 分类id
        type: "", // 类型：1成人穴位2儿童穴位
        definition_pic_path: "", // 概述定义的图片路径
        definition_pinyin: "", // 拼音
        definition_cat_belongs_to: "", // 所属经络
        definition_major_functions: "", // 主治
        acupoint_selection_title: "", // 快速取穴
        acupoint_selection_content: "", // 取穴内容
        acupoint_selection_pic_path: "", // 取穴图片路径
        acupoint_range: "", // 适用范围 （小儿）
        acupoint_mark: "", // 备注 （小儿）
        acupoint_match: "", // 穴位配伍
      },
      modify: false,
      confirmText: "确认添加",
      uploadToken: {
        // 图片上传附带的token参数
        token: this.$store.getters.userinfo.login_token,
      },
      formType: 1, // 1:成人穴位 2:小二穴位
    };
  },
  created() {
    const { type, id, child } = this.$route.query;
    if (type == "modify") {
      this.form.id = id;
      this.formType = child;
      let type = {
        0: "旧类型",
        1: "成人穴位",
        2: "小儿穴位",
      };
      this.form.type = type[child];
      this.modify = true;
      this.confirmText = "确认修改";
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取经络
    getData() {
      categoryList().then((res) => {
        this.options = res.data.list;
        if (this.modify) {
          acupointDetail({
            id: this.form.id,
          }).then((res) => {
            let option = this.options.find((e) => e.id == res.data.cat_id);
            let type = {
              0: "旧类型",
              1: "成人穴位",
              2: "小儿穴位",
            };
            this.form = res.data;
            this.form.type = type[option.type];
          });
        }
      });
    },
    // 图片上传成功
    handleAvatarSuccess(res, file, fileList, type) {
      this.$message.closeAll();
      if (res.code == 402) {
        this.$message.error("已下线,请重新登录");
        this.$router.replace("login");
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        const { path, filename } = res.data.files[0];
        if (type == 1) {
          this.form.definition_pic_path = path + filename;
        } else {
          this.form.acupoint_selection_pic_path = path + filename;
        }
      }
    },
    // 图片上传失败
    handleAvatarError(res) {
      this.$message.closeAll();
      this.$message({
        showClose: true,
        message: "上传失败" + res,
        type: "error",
      });
    },
    // 图片上传之前
    beforeAvatarUpload(file) {
      this.$message({
        duration: 0,
        showClose: true,
        message: "正在上传，请稍后...",
      });
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 预览图片
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisibleImg = true;
    },
    // 删除图片
    handlePictureDelete(key) {
      this.form[key] = "";
    },
    /**
     * 选中了经络
     */
    selectCatId(val) {
      const option = this.options.find((e) => e.id == val);
      let type = {
        0: "旧类型",
        1: "成人穴位",
        2: "小儿穴位",
      };
      this.formType = option.type;
      this.form.type = type[option.type];
    },
    // 确认提交
    onSubmit() {
      const {
        id,
        name,
        cat_id,
        definition_pic_path,
        definition_pinyin,
        definition_cat_belongs_to,
        definition_major_functions,
        acupoint_selection_title,
        acupoint_selection_content,
        acupoint_selection_pic_path,
        acupoint_range,
        acupoint_mark,
        acupoint_match,
      } = this.form;
      if (name == "") {
        this.$message.error("穴位名称不能为空");
      } else if (cat_id == "") {
        this.$message.error("经络不能为空");
      } else if (definition_pic_path.length == 0) {
        this.$message.error("概述图片不能为空");
      } else if (definition_pinyin == "") {
        this.$message.error("拼音不能为空");
      } else if (definition_cat_belongs_to == "") {
        this.$message.error("所属经络不能为空");
      } else if (definition_major_functions == "") {
        this.$message.error("主治内容不能为空");
      } else if (acupoint_selection_title == "") {
        this.$message.error("快速取穴不能为空");
      } else if (acupoint_selection_content == "") {
        this.$message.error("取穴内容不能为空");
      } else {
        this.$confirm("是否确认提交内容?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.form.id = this.modify ? id : 0;
          saveAcupoint({
            id,
            name,
            cat_id,
            definition_pic_path,
            definition_pinyin,
            definition_cat_belongs_to,
            definition_major_functions,
            acupoint_selection_title,
            acupoint_selection_content,
            acupoint_selection_pic_path,
            acupoint_range,
            acupoint_mark,
            acupoint_match,
          }).then(() => {
            if (this.modify) {
              this.$message.success("修改成功!");
              this.goback();
            } else {
              Object.keys(this.form).map((e) => {
                this.form[e] = "";
              });
              this.$message.success("添加成功!");
            }
          });
        });
      }
    },
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped src="@/assets/css/avatorUploader.css"></style>
<style scoped></style>
